<template>
  <v-container>
    <v-alert
      v-if="store.status.valid != undefined"
      text
      type="info"
      class="mt-8"
    >
        รายการสินค้าบางส่วนได้ถูกย้ายไปใน <strong><a class="link info--text" :href="`${appRPTUrl}/mystore/store`">ReptTown.com</a></strong> ตั้งแต่วันที่ 25/12/2564
    </v-alert>

    <v-card class="pa-4">
      <v-row
        no-gutters
        class="py-2 px-4 align-center text-h5 font-weight-medium primary--text"
      >
        {{ $langs.MyStore.myStore[$langs.lang] }}
        <v-spacer></v-spacer>
        <a
          :href="`/stores/s/${store._id}?store=true`"
          target="_blank"
          class="text-subtitle-2"
          >{{ $langs.MyStore.previewMyStore[$langs.lang] }}</a
        >
      </v-row>

      <v-row>
        <!-- Left Panel -->
        <v-col class="shrink menu-cols">
          <div class="text-center">
            <v-expand-transition mode="out-in">
              <div v-if="hideUploadLogoBtn">
                <div>
                  <!-- Store Logo Image -->
                  <v-avatar size="100">
                    <v-img :src="logoImage" class="grey"></v-img>
                  </v-avatar>
                </div>

                <input
                  type="file"
                  accept="image/*"
                  ref="file"
                  hidden
                  @change="onFilesSelected"
                />
                <!-- Upload Button -->
                <v-btn
                  x-small
                  color="primary"
                  class="mt-3"
                  for="file"
                  @click="$refs.file.click()"
                  >{{ $langs.Gen.upload[$langs.lang] }}</v-btn
                >
                <v-divider class="my-4 mx-3"></v-divider>
              </div>
            </v-expand-transition>
          </div>

          <!-- Aside List Menu -->
          <v-list dense nav class="pa-0">
            <v-list-item
              v-for="item in items"
              :key="item.title"
              link
              :to="item.path"
              :disabled="item.disabled"
              exact-path
            >
              <v-list-item-content>
                <v-list-item-title
                  ><v-icon left>{{ item.icon }}</v-icon>
                  {{ item.title }}</v-list-item-title
                >
              </v-list-item-content>
            </v-list-item>
          </v-list>
        </v-col>

        <!-- Right Main Panel -->
        <router-view
          :store="store"
          :logoImage="logoImage"
          @change="getStoreInfo()"
        ></router-view>
      </v-row>
    </v-card>

    <!-- Show Store Status -->
    <v-alert
      v-if="store.status.valid != undefined"
      text
      :type="alertType"
      class="mt-8"
    >
      <template v-if="storeIsApproved">
        This store is <strong>approved.</strong>
      </template>
      <template v-if="storeBeingReview">
        This store is <strong>being review,</strong> please wait for admin to
        approve.
      </template>
      <template v-if="storeIsNotApproved">
        <div>This store is <strong>not approved.</strong></div>
        <div class="text-subtitle-2">Detail: {{ store.status.detail }}</div>
      </template>
    </v-alert>
  </v-container>
</template>

<script>
import store from "../../services/store";
import api from "../../services/api";
import user from "../../services/user";
import { storeImageUrl, compressImages, appRPTUrl } from "../../services/constants";

export default {
  data() {
    return {
      // logoImage: "https://picsum.photos/510/300?random",
      logoImage: "",
      store: {
        address: {},
        contact: {},
        description: "",
        logoImage: "",
        sellerAccount: {},
        status: {},
        storeName: "",
        user: "",
        _id: "",
      },
      items: [
        {
          title: this.$langs.MyStore.myStore[this.$langs.lang],
          icon: "home",
          path: "/mystore/store",
        },
        {
          title: this.$langs.Product.productManagement[this.$langs.lang],
          icon: "mdi-view-dashboard",
          path: "/mystore/product",
          disabled: true,
        },
      ],
      fileSize: 0,
      loading: false,
      change: false,
      MAX_LOGO_SIZE: 2,

      appRPTUrl: appRPTUrl,
    };
  },
  mounted() {
    this.store = { ...this.store, ...user.restore().storeInfo };
    if (this.store.status.valid) this.items[1].disabled = false;
    this.getStoreInfo();
    // console.log(this.$route.matched);
  },
  methods: {
    async onFilesSelected(event) {
      this.store.logoImage = "";
      this.logoImage = URL.createObjectURL(event.target.files[0]);
      let file = (await compressImages([...event.target.files], { quality: 'MID' }))[0];
      this.store.logoImage = file;
      this.fileSize = (file.size / 1000000).toFixed(2);
    },
    async getStoreInfo() {
      this.loading = true;
      let _store = await store.getStoreInfo();
      this.loading = false;
      if (!_store) return;
      if (_store.success == false) return api.makeAlert(_store.msg, "error");
      if (!_store.address) {
        _store.address = {};
        api.makeAlert("Please fill in 'Store Location'", "info", 10);
      }
      if (!_store.logoImage)
        api.makeAlert("Please Upload 'Logo Image'", "info", 8);
      if (!_store.contact) {
        _store.contact = {};
        setTimeout(() => {
          api.makeAlert("Please fill in 'Store Contact'", "info", 10);
        }, 500);
      }
      if (_store.status.valid) this.items[1].disabled = false;

      // Remove Empty field
      for (let k of ["address", "contact"])
        for (let key in _store[k]) if (!_store[k][key]) delete _store[k][key];

      if (_store.logoImage) this.logoImage = storeImageUrl(_store.logoImage);
      this.store = _store;
      user.updateLoginInfo({ storeInfo: _store });
    },
  },
  computed: {
    storeBeingReview() {
      return this.store.status.valid == false && !this.store.status.detail;
    },
    storeIsApproved() {
      return this.store.status.valid == true;
    },
    storeIsNotApproved() {
      if (this.storeBeingReview) return false;
      return this.store.status.valid == false;
    },
    alertType() {
      if (this.storeIsApproved) return "success";
      if (this.storeIsNotApproved) return "error";
      return "info";
    },
    hideUploadLogoBtn() {
      if (this.$route.path.indexOf("/mystore/product") != -1) return false;
      return true;
    },
  },
  metaInfo() {
    return {
      title: "My Store",
      titleTemplate: "%s · Marketpett",
      meta: [{ name: "robots", content: "noindex" }],
    };
  },
};
</script>


<style lang="scss" scoped>
.menu-cols {
  flex-basis: 100%;

  @media #{map-get($display-breakpoints, 'md-and-up' )} {
    flex-basis: 220px;
  }
}
</style>